import { Box, Modal } from "@mui/material";
import React, { useState, useEffect } from "react";

export default function BlogBodyRenderer({ body }) {
  const [openImage, setOpenImage] = useState(null);

  const cleanedBody = body.replace(/<p>\s*<\/p>/g, "<br />");

  return (
    <>
      <Box
        sx={{
          "& a": {
            color: "primary.main",
            textDecoration: "underline",
            fontWeight: "bold",
            cursor: "pointer",
          },

          "& a:hover": {
            opacity: 0.8,
          },

          "& figure[data-type='image']": {
            margin: "16px 0",
            position: "relative",
            cursor: "zoom-in",
          },

          "& img": {
            maxWidth: "100%",
            height: "auto",
            display: "block",
            borderRadius: 1,
          },

          "& img[data-align='left']": {
            marginRight: "auto",
            marginLeft: 0,
          },

          "& img[data-align='center']": {
            marginLeft: "auto",
            marginRight: "auto",
          },

          "& img[data-align='right']": {
            marginLeft: "auto",
            marginRight: 0,
          },

          "& img[data-width='small']": {
            width: "200px",
          },

          "& img[data-width='medium']": {
            width: "400px",
          },

          "& img[data-width='large']": {
            width: "100%",
          },

          "& figcaption": {
            fontSize: "0.875rem",
            color: "text.secondary",
            textAlign: "center",
            mt: 1,
          },

          "& p:empty": {
            display: "inline",
          },

          "& p:empty::after": {
            content: '"\\A"',
            whiteSpace: "pre",
          },
        }}
        dangerouslySetInnerHTML={{
          __html: cleanedBody,
        }}
        onClick={(e) => {
          const img = e.target.closest("img");
          if (!img) return;

          setOpenImage(img.src);
        }}
      />

      {/* 🟢 LIGHTBOX */}
      <Modal
        open={!!openImage}
        onClose={() => setOpenImage(null)}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          onClick={() => setOpenImage(null)}
          sx={{
            outline: "none",
            maxWidth: "90vw",
            maxHeight: "90vh",
          }}
        >
          {openImage && (
            <img
              src={openImage}
              style={{
                maxWidth: "90vw",
                maxHeight: "90vh",
                objectFit: "contain",
                borderRadius: 8,
              }}
            />
          )}
        </Box>
      </Modal>
    </>
  );
}
